module.exports = __webpack_public_path__ + "static/media/taltnoje.ee2aa981.png";